<template>
  <div>
    <div>
      <div class="wrp">
        <div class="top-tit">Product Categories</div>
        <h1 class="clear">
          <span @click="linkTo('/revenue')">Revenue History</span>
          <span v-if="isRevenueTargetForecastActivated" @click="linkTo('/revenue-forcasting')">Revenue
            Forecasting</span>
          <span @click="linkTo('/income')" v-if="doshiiFlag">Doshii Area</span>
          <span @click="linkTo('current')" class="active">Product Categories</span>
          <span v-if="(oseriesFlag || squareFlag) && isPro" @click="linkTo('/terminals')">Terminals</span>
          <span v-if="(oseriesFlag || tevalisFlag || redcatFlag || swiftPosFlag || squareFlag || oolioFlag) && isPro" @click="linkTo('/revenue-group')">Revenue Group</span>
          <span v-if="!squareFlag && !swiftPosFlag" @click="linkTo('/accounting-categories')">Accounting Categories</span>
        </h1>
        <!-- Terminals  -->
        <div v-if="!redcatFlag && !oseriesFlag && !oolioFlag">
          <div class="revenue-more custom-table table-wrp">
            <el-table :data="terminalTable" border style="width: 100%">
              <el-table-column prop="name">
                <template slot-scope="scope">
                  <div :class="`teminals-item teminals-item__${terminalStatus(scope.row.transactionsState)}`">
                    <svg v-if="terminalStatus(scope.row.transactionsState) == 'success'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
                    </svg>
                    <svg v-else-if="terminalStatus(scope.row.transactionsState) == 'warning'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/>
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"/>
                    </svg>
                    <span>{{scope.row.name}}</span>
                  </div>
                </template>
                <template slot="header" slot-scope="scope">
                  <div class="table-header">
                    <h2>Terminals</h2>
                    <div v-if="isPro">
                      <button href="#" class="table-header__button" @click="openModal(true, 'terminal')">Edit</button>
                    </div>
                  </div>
                </template>
              </el-table-column>

              <template slot="empty">
                <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
                <div v-else>No Data</div>
              </template>
            </el-table>

          </div>
        </div>

        <!-- FOOD -->
        <div>
          <div class="revenue-more custom-table table-wrp">
            <el-table :data="foodTable" border style="width: 100%">
              <el-table-column prop="name" align="left">
                <template slot="header" slot-scope="scope">
                  <div class="table-header">
                    <h2>Food</h2>
                    <div v-if="isPro">
                      <button href="#" class="table-header__button" @click="openModal(true, 'food')">Edit</button>
                    </div>
                  </div>
                </template>
              </el-table-column>

              <template slot="empty">
                <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
                <div v-else>No Data</div>
              </template>
            </el-table>

          </div>
        </div>

        <div>
          <div class="revenue-more custom-table table-wrp">
            <el-table :data="beverageTable" border style="width: 100%">
              <el-table-column prop="name">
                <template slot="header" slot-scope="scope">
                  <div class="table-header">
                    <h2>Beverage</h2>
                    <div v-if="isPro">
                      <button href="#" class="table-header__button" @click="openModal(true, 'beverage')">Edit</button>
                    </div>
                  </div>
                </template>
              </el-table-column>

              <template slot="empty">
                <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
                <div v-else>No Data</div>
              </template>
            </el-table>

          </div>
        </div>

      </div>

    </div>


    <modal-edit-sites-register :revenueType="revenueType" :open="modalOpen" :type="type" @close-modal="modalClose"
      @fetch-data="fetchData"></modal-edit-sites-register>
  </div>
</template>

<script>
import api from "../../api/dashboard";
import modalEditSitesRegister from '../modal/editSiteRegisterModal.vue'
export default {
  inject: ['reload'],
  data() {
    return {
      doshiiFlag: false,
      isRevenueTargetForecastActivated: false,
      isPro: false,
      foodTable: [],
      beverageTable: [],
      terminalTable: [],
      products: [],
      terminals: [],
      venueId: null,
      type: null,
      modalOpen: false,
      loading: false,
      oseriesFlag: false,
      squareFlag: false,
      oolioFlag: false,
      tevalisFlag: false,
      redcatFlag: false,
      swiftPosFlag: false,
      revenueType: 'oseries',
    }
  },
  components: { modalEditSitesRegister },
  methods: {
    linkTo(path) {
      if (path === 'current') {
        this.reload()
      } else {
        this.$router.push(path)
      }
    },
    terminalStatus (state) {
      switch (state) {
        case 'TRANSACTIONS_WITHIN_RANGE':
          return 'success'
        case 'HAS_TRANSACTIONS':
          return 'warning'
        default:
          return 'danger'
      }
    },
    openModal(open, type) {
      this.type = type;
      this.modalOpen = open;
    },
    modalClose() {
      this.type = null;
      this.modalOpen = false;
    },
    async fetchData() {
      this.venueId = window.sessionStorage.getItem("subVenueId");


      if (this.revenueType == 'redcat' || this.revenueType == 'tevalis') {
        const terminals = await api.getVenueTerminalList({venueId: this.venueId}, this.revenueType)

        if (this.revenueType == 'tevalis') {
          this.terminalTable = terminals.data.data.map((n) => {
            var data = {
              name: n.name,
              hasLatestOrder: n.latestOrder ? true : false,
              transactionsState: n.transactionsState,
            }
            return data
          })
        } else {
          this.terminalTable = terminals.data.data
        }
      } else if (this.revenueType == 'square') {
        const terminals = await api.getVenueDevicesNew(this.revenueType)
        this.terminalTable = terminals.data.data
      } else if (this.revenueType == 'swiftpos') {
        const terminals = await api.getVenueTerminalsNew(this.revenueType)
        this.terminalTable = terminals.data.data
      } else {

        if (this.revenueType != 'oseries' && this.revenueType != 'oolio') {
          const terminals = await api.getVenueTerminalList({venueId: this.venueId}, this.revenueType)
          this.terminalTable = terminals.data.data
        }

      }

      if (this.revenueType == 'square' || this.revenueType == 'swiftpos') {
        const foodData = await api.getVenueCategoriesNew('food', this.revenueType);
        if (foodData.data.code == 0) {
          this.foodTable = foodData.data.data;
        }

        const beverageData = await api.getVenueCategoriesNew('beverage', this.revenueType);
        if (beverageData.data.code == 0) {
          this.beverageTable = beverageData.data.data;
        }

        const productData = await api.getVenueCategoriesNew('options', this.revenueType);
        if (productData.data.code == 0) {
          this.products = productData.data.data;
        }

      } else if (this.revenueType == 'oolio') {
        this.loading = true;
        const productData = await api.getVenuePosCategories('', this.revenueType);
        if (productData.data.code == 0) {
          this.products = productData.data.data;
        }

        const foodData = await api.getVenuePosCategories('food', this.revenueType);
        if (foodData.data.code == 0) {
          this.foodTable = foodData.data.data.map((n) => {
            const product = this.products.find(e => e.id == n);
            return { id: n, name: product ? product.name : 'Unknown' };
          });
        }

        const beverageData = await api.getVenuePosCategories('beverage', this.revenueType);
        if (beverageData.data.code == 0) {
          this.beverageTable = beverageData.data.data.map((n) => {
            const product = this.products.find(e => e.id == n);
            return { id: n, name: product ? product.name : 'Unknown' };
          });
        }
        this.loading = false;
      } else {
        const foodData = await api.getVenueFood({ venueId: this.venueId }, this.revenueType);
        if (foodData.data.code == 0) {
          this.foodTable = foodData.data.data;
        }

        const beverageData = await api.getVenueBeverage({ venueId: this.venueId }, this.revenueType);
        if (beverageData.data.code == 0) {
          this.beverageTable = beverageData.data.data;
        }

        const productData = await api.getAllProducts({ venueId: this.venueId }, this.revenueType);
        if (productData.data.code == 0) {
          this.products = productData.data.data;
        }
      }
    },
  },
  async mounted() {
    this.loading = true;


    api.progress({
      callback: async (res) => {
        if (res.data.code === 0 && res.data.data.doshiiFlag) {
          this.doshiiFlag = true
        }

        if (res.data.code === 0 && res.data.data.oseriesFlag) {
          this.oseriesFlag = true;
          this.revenueType = 'oseries';
        } else if (res.data.code === 0 && res.data.data.tevalisFlag) {
          this.tevalisFlag = true;
          this.revenueType = 'tevalis';
        } else if (res.data.code === 0 && res.data.data.redcatFlag) {
          this.redcatFlag = true;
          this.revenueType = 'redcat';
        } else if (res.data.code === 0 && res.data.data.oolioFlag) {
          this.oolioFlag = true;
          this.revenueType = 'oolio';
        } else if (res.data.code === 0 && res.data.data.squareFlag) {
          this.squareFlag = true;
          this.revenueType = 'square';
        } else if (res.data.code === 0 && res.data.data.swiftPosFlag) {
          this.swiftPosFlag = true;
          this.revenueType = 'swiftpos';
        }  else {
          this.linkTo('/revenue')
        }


        this.fetchData();

      }
    })
    this.loading = false;


  },
  created() {
    this.$root.$on('isPro', (isPro, others) => {
      this.isPro = isPro
      this.isRevenueTargetForecastActivated = others.isRevenueTargetForecastActivated
    })
  }
}
</script>


<style lang="scss" scoped>

.teminals-item {
  display: flex;
  align-items: center;
  gap: 20px;

  &__success {
    svg {
      fill: #2ecc71;
    }
  }

  &__danger {
    svg {
      fill: #e74c3c;
    }
  }

  &__warning {
    svg {
      fill: #f39c12;
    }
  }
}
.table-header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;

  h2 {
    font-size: 20px;
    font-weight: 600;
  }

  &__button {
    border: 2px solid #EA3796;
    padding: 8px 25px !important;
    font-size: 15px;
    color: #EA3796;
    height: auto !important;
    width: auto !important;
  }
}

.wrp {
  width: 100%;

  .top-tit {
    font-size: 24px;
    color: var(--text-color);
    line-height: 28px;
    margin-bottom: 38px;
    font-weight: 600;
  }

  .red {
    color: #EA3796;
  }

  h1 {
    font-size: 20px;
    margin-bottom: 39px;
    font-weight: 600;
    line-height: 60px;
    margin-bottom: 27px;

    span {
      float: left;
      position: relative;
      cursor: pointer;
      color: #A6A7A9;
      margin-right: 36px;
    }

    .active {
      color: var(--text-color);

      &:after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 110%;
        height: 2px;
        background: #EA3796;
      }
    }

    button {
      float: right;
      display: block;
      outline: none;
      background: none;
      cursor: pointer;
      width: 280px;
      height: 60px;
      border: 2px solid #EA3796;
      color: #EA3796;
      margin: 0 auto;
      font-size: 26px;
    }
  }

  .table-wrp {
    margin-bottom: 30px;

    .icon {
      display: inline-block;
      width: 24px;
      height: 24px;
      mask-repeat: no-repeat !important;
      mask-size: 24px 24px !important;
      mask-position: center center !important;
      background-color: var(--text-color);
      mask: url('../../assets/pencil-square.svg');
      -webkit-mask: url('../../assets/pencil-square.svg');
      cursor: pointer;
    }
  }

  .btns {
    margin: 65px auto 0 auto;
    width: 610px;
  }

  button {
    width: 280px;
    height: 60px;
    outline: none;
    background: none;
    cursor: pointer;
    font-weight: 600;
  }

  .dark {
    border: 2px solid var(--text-color);
    color: var(--text-color);
    font-size: 26px;
    float: left;
  }

  .light {
    border: 2px solid #8E3771;
    color: #8E3771;
    font-size: 26px;
    float: right;
  }

  .usable {
    border: 2px solid #EA3796;
    color: #EA3796;
  }

  .pop-wrp {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    background: var(--background-color-2);
    bottom: 0;
    right: 0;
    z-index: 102;

    .pop-confirm {
      width: 1250px;
      height: 280px;
      background: var(--background-color-4);
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -140px 0 0 -625px;

      .triple {
        text-align: center;

        button {
          width: 280px;
          height: 60px;
          background: var(--background-color-4);
          box-sizing: border-box;
          font-size: 26px;
          font-family: PingFangSC-Semibold, PingFang SC;
        }

        button:nth-child(1),
        button:nth-child(2) {
          margin-right: 50px;
        }

        button:nth-child(1) {
          color: var(--text-color);
          border: 2px solid var(--text-color);
        }

        button:nth-child(3),
        button:nth-child(2) {
          color: #D13A90;
          border: 2px solid #D13A90;
        }
      }
    }

    h1 {
      font-size: 24px;
      line-height: 33px;
      font-weight: 600;
      margin-bottom: 50px;
      color: var(--text-color);
      text-align: center;
    }

    .btns {
      margin: 65px auto 0 auto;
      width: 610px;

      button {
        width: 280px;
        height: 60px;
        outline: none;
        background: none;
        cursor: pointer;
        font-weight: 600;
      }

      .dark {
        border: 2px solid var(--text-color);
        color: var(--text-color);
        font-size: 26px;
        float: left;
      }

      .light {
        border: 2px solid #8E3771;
        color: #8E3771;
        font-size: 26px;
        float: right;
      }

      .usable {
        border: 2px solid #EA3796;
        color: #EA3796;
      }
    }

    .normal {
      transform: rotate(0deg);
      opacity: 1;
      margin-left: -420px;
    }

    .second-step {
      width: 840px;
      height: 612px;
      background: var(--background-color);
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -306px 0 0 -420px;
      box-sizing: border-box;
      padding: 65px 50px 0 50px;

      h2 {
        margin-bottom: 30px;
      }

      .upload-con {
        width: 100%;
        height: 280px;
        background: var(--background-color-2);
        box-sizing: border-box;
        border: 1px solid #5F5F5F;
        position: relative;
        text-align: center;

        .close {
          width: 20px;
          position: absolute;
          height: 20px;
          right: 28px;
          top: 69px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center center;
          background-image: url('../../assets/c.png');
          cursor: pointer;
        }

        .icon {
          display: block;
          width: 100%;
          height: 35px;
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center center;
          background-image: url('../../assets/upload.png');
          margin-top: 80px;
          margin-bottom: 30px;
        }

        h3 {
          font-size: 20px;
          line-height: 28px;
          text-align: center;
          color: var(--text-color);

          span {
            color: #D13A90;
          }
        }

        .upload-demo {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          bottom: 0;
        }

        .el-icon-loading {
          margin-top: 100px;
          font-size: 30px;
        }

        .file {
          width: 660px;
          height: 120px;
          background: var(--background-color-4);
          position: relative;
          margin: 80px auto 0 auto;
          display: flex;
          flex-direction: row;
          box-sizing: border-box;
          padding: 20px;

          .in {
            width: 80px;
            height: 80px;
            margin-right: 20px;
            background-size: contain;
            background-image: url('../../assets/a.png');
            background-position: center center;
            background-repeat: no-repeat;
            flex: 0 0 auto;
          }

          .text {
            flex: 0 0 auto;
            text-align: left;
            width: 520px;

            .tit {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
              font-size: 24px;
              line-height: 33px;
              margin-bottom: 10px;
              margin-top: 5px;
            }

            .size {
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
              font-size: 20px;
              line-height: 28px;
            }
          }
        }
      }
    }

    .upload-success {
      width: 410px;
      height: 349px;
      background: var(--background-color);
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -176px 0 0 -210px;
      box-sizing: border-box;
      padding: 60px 50px 0 50px;

      i {
        display: block;
        width: 100%;
        height: 60px;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center center;
        margin-bottom: 40px;
        background-image: url('../../assets/s.png');
      }

      h4 {
        font-size: 24px;
        line-height: 29px;
        margin-bottom: 50px;
        color: var(--text-color);
        text-align: center;
      }

      button {
        width: 100%;
      }
    }

    .lst {
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;

      input {
        width: 100%;
        margin: 0;
        padding: 0;
        background: none;
        outline: none;
        border: none;
        font-size: 16px;
        color: var(--text-color);
        box-sizing: border-box;
        padding: 0 10px;
        text-align: center;
      }

      .box {
        width: 1250px;
        background: var(--background-color);
        box-sizing: border-box;
        padding: 65px 50px 65px 50px;

        .table-wrp {
          margin-bottom: 15px;
        }

        p {
          font-size: 18px;
          line-height: 25px;
          color: var(--text-color);
        }
      }
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter,
  .fade-leave-to

  /* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/revenue/productCategories.vue